import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { bulkClUpdateClient } from '@/services/http/clients/bulkClUpdateClient';
import { notificationService } from '@/services/notification/notification.client';

export function useDeleteUploadedFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const deleteFile = (id: UUID, successCallback?: Function) => {
    toggleLoadingAnimation(true);

    const requestUrl = '/DeleteDocumentFunction';
    bulkClUpdateClient.delete(requestUrl, {
      params: {
        documentId: id,
      },
    })
      .then((response) => {
        if (response?.status === HttpStatusCode.OK) {
          notificationService.open({
            title: 'Delete file',
            text: 'File deleted successfully',
            type: 'success'
          });
          successCallback?.();
        }
      })
      .catch((err) => {
        notificationService.open({
          title: 'Error',
          text: err?.message ?? DEFAULT_ERROR_MESSAGE,
          type: 'danger'
        });
      })
      .finally(() => toggleLoadingAnimation(false));
  };

  return {
    deleteFile
  } as const;
}
